import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import logo from '../assets/images/logo.png';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 960);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 960);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Scroll to top when route changes
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [location]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const handleNavClick = () => {
    toggleMenu();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      const navMenu = document.querySelector('.nav-menu');
      const menuIcon = document.querySelector('.menu-icon');
      
      if (isOpen && navMenu && !navMenu.contains(event.target) && !menuIcon.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  // Close menu when route changes
  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  return (
    <nav className="navbar">
      <Link to="/" className="navbar-logo" onClick={() => {
        closeMenu();
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }}>
        <img src={logo} alt="The Black Cat Logo" className="logo-image" />
        <div className="logo-text">
          <span className="spooky-text">BLACK CAT PARANORMAL</span>
          <span className="subtitle">Ghost Hunting</span>
        </div>
      </Link>
      
      <div className="nav-right">
        {!isMobile && (
          <div className="social-icons">
            <a
              className="social-icon-link"
              href="https://www.tiktok.com/@blackcat_paranormal"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="TikTok"
            >
              <i className="fab fa-tiktok" />
            </a>
            <a
              className="social-icon-link"
              href="https://www.youtube.com/@Bc.Paranormal"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Youtube"
            >
              <i className="fab fa-youtube" />
            </a>
            <a
              className="social-icon-link"
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
            >
              <i className="fab fa-twitter" />
            </a>
          </div>
        )}
        
        <div className="mobile-social-icons">
          <a
            className="social-icon-link"
            href="https://www.tiktok.com/@blackcat_paranormal"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="TikTok"
          >
            <i className="fab fa-tiktok" />
          </a>
          <a
            className="social-icon-link"
            href="https://www.youtube.com/@Bc.Paranormal"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Youtube"
          >
            <i className="fab fa-youtube" />
          </a>
          <a
            className="social-icon-link"
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Twitter"
          >
            <i className="fab fa-twitter" />
          </a>
        </div>
        
        <ul className={isOpen ? 'nav-menu active' : 'nav-menu'}>
          <li className="nav-item">
            <Link 
              to="/" 
              className={location.pathname === '/' ? 'nav-links active' : 'nav-links'} 
              onClick={handleNavClick}
            >
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/about" 
              className={location.pathname === '/about' ? 'nav-links active' : 'nav-links'} 
              onClick={handleNavClick}
            >
              About Us
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/merch" 
              className={location.pathname === '/merch' ? 'nav-links active' : 'nav-links'} 
              onClick={handleNavClick}
            >
              Merch
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/contact" 
              className={location.pathname === '/contact' ? 'nav-links active' : 'nav-links'} 
              onClick={handleNavClick}
            >
              Contact
            </Link>
          </li>
        </ul>
        
        <div className="menu-icon" onClick={toggleMenu}>
          <i className={isOpen ? 'fas fa-times' : 'fas fa-bars'}></i>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
